
import React from 'react';

interface ToggleSwitchProps {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  label?: string;
  ariaLabel: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isChecked, onChange, label, ariaLabel }) => {
  return (
    <label htmlFor={ariaLabel} className="flex items-center cursor-pointer">
      {label && <span className="mr-2 text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>}
      <div className="relative">
        <input
          type="checkbox"
          id={ariaLabel}
          className="sr-only"
          checked={isChecked}
          onChange={() => onChange(!isChecked)}
          aria-label={ariaLabel}
        />
        <div className={`block w-12 h-6 rounded-full transition-colors ${isChecked ? 'bg-indigo-600' : 'bg-gray-300 dark:bg-gray-600'}`}></div>
        <div className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${isChecked ? 'translate-x-6' : 'translate-x-0'}`}></div>
      </div>
    </label>
  );
};

export default ToggleSwitch;
